import { createModelStore } from '@/shared/stores/create-model-store'
import { model1_3InitialModel } from './initial-state'
import { model1_3DimensionHandlers } from './dimensions'

export const useModel1_3Store = createModelStore({
  initialModel: model1_3InitialModel,
  dimensionHandlers: model1_3DimensionHandlers,
})
